<ng-container>
    <a [ngClass]="{'is-active': authState?.language === 'it'}" class="c-page-head-nav__link" (click)="setLanguage('it')">IT</a>
    <a class="c-page-head-nav__link">/</a>
    <a [ngClass]="{'is-active': authState?.language === 'en'}" class="c-page-head-nav__link" (click)="setLanguage('en')">EN</a>
</ng-container>
